<template>
 <div class="foot">
     <div class="foot-content">
            <div>
                    <div class="foot-title">影音新时代网 | 站点地图 | 友情链接 | 联系我们</div>
                    <div class="public-num">公安部备案： 61019002000037</div>
            </div>
            <div style="padding-top:20px"><img style="width:100px;height:100px" src="@/assets/code.png" alt=""></div> 
     </div>
    <div class="foot-box">
       <div>Powered by 影音新时代网 © 2002-20015 家庭影院音响公众网络平台</div>
       <div>本站系统 by SupeSite © 2001-20013 Comsenz Inc.</div>
       <div>扫一扫下载APP</div>
   </div>
 </div>
</template>

<script>
    export default {
  name: 'App'
}
</script>

<style scoped>
.foot{
    height: 190px;
    background: #272727;
    box-sizing: border-box;
    padding: 0 15%;
    width: 100%;
}
.foot-title{
    font-size: 14px;
    color: #FFFFFF;
    opacity: 0.5;
    padding-top: 20px;
    border-bottom: 1px solid #fff;
    height: 30px;
}
.foot-box{
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #FFFFFF;
    opacity: 0.5;
}
.foot-content{
    display: flex;
    justify-content: space-between;
}
.public-num{
    font-size: 14px;
    color: #FFFFFF;
    opacity: 0.5;
    padding-top: 47px
}
</style>



// WEBPACK FOOTER //
// src/components/common/Foot.vue